<template>
	<main id="subPage" class="admin">
		<!-- 카테고리 -->
        <section id="category">
			<h2>관리자 메뉴</h2>
			<ul class="breadCrumb">
				<li class="home"></li>
				<li class="web">
					<p class="pageTxt">관리자 메뉴</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
						<li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
					</ul> 
				</li>
                <li class="web">
					<p class="pageTxt">게시판 관리</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
						<li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
						<li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
                        <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
						<li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
					</ul> 
				</li>
                <li>
					<p class="pageTxt">자주묻는질문 관리</p>
					<ul class="depth">
						<li><router-link to="/noticemanagement" title="공지사항 관리">공지사항 관리</router-link></li>
						<li><router-link to="/faqmanagement" title="자주묻는질문 관리">자주묻는질문 관리</router-link></li>
					</ul> 
				</li>
			</ul>
        </section>

		<!-- 컨텐츠 영역 -->
		<section id="content">
			<div class="inner">
				<h3 class="pageTitle">자주묻는질문 조회</h3>
                <article>
                    <!--table-->
                    <div class="table horizontal-table noticeView">
                        <table>
                            <caption>자주묻는질문 조회 테이블</caption>
                            <colgroup>
                                <col style="width: 20%;">
                                <col style="width: auto;">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td colspan="2">
                                        <div class="tableTitle">
                                            <p class="tit">{{ faqInfo.title }}</p>
                                            <div class="right">
                                                <span class="writer">김**</span>
                                                <span class="date">2022-08-31</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="tableCont">
                                        <pre name="" id="" >
                                            <div v-html="faqInfo.cts"></div>
                                        </pre>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--table-->
                </article>
                <article class="btnArea">
                    <button class="btn border" @click="$router.push('faqmanagement')">목록</button>
                    <button class="btn gray" @click="deleteConfirm">삭제</button>
                    <button class="btn blue" @click="update">수정</button>
                </article>

                <article>
                    <!--table-->
                    <div class="table horizontal-table">
                        <table>
                            <caption>자주묻는질문 조회 테이블</caption>
                            <colgroup>
                                <col style="width:10%; min-width: 80px;"/>
                                <col style="width:15%"/>
                                <col style="width:10%; min-width: 80px;"/>
                                <col style="width:15%"/>
                                <col style="width:10%; min-width: 80px;"/>
                                <col style="width:15%"/>
                                <col style="width:10%; min-width: 80px;"/>
                                <col style="width:15%"/>
                            </colgroup>
                            <tbody>
                                <tr style="border-top: 1px solid #E0E0E0;">
                                    <th scope="row">작성자</th>
                                    <td>관리자</td>
                                    <th scope="row">작성일</th>
                                    <td>2022-12-28 09:58</td>
                                    <th scope="row">수정자</th>
                                    <td>-</td>
                                    <th scope="row">수정일</th>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--//table-->

                </article>
            </div>
        </section>
	</main>
</template>

<script>
import axios from "../../../util/axios";

export default {
	data(){
        return {
            atclId: "",
            faqInfo: {},
            attachList: [],
		}
	},
	
    mounted() {
        const atclId = this.$route.query.atclId
        if(!atclId) {
			alert("잘못된 접근입니다.");
			this.$router.push('/faqmanagement');
        }
        this.atclId = atclId;
        this.findFaq();
	},

    methods: {
        async findFaq() {
            const res = await axios('get', "/api/admin/board/faq/view.json", {
                atclId: this.atclId,
				bbsCd: "faq"
            });
            this.faqInfo = res.data.boardView;
            this.attachList = res.data.attachList;
        },

        update(){
			const params = {
				atclId : this.faqInfo.atclId,
				title  : this.faqInfo.title,
				cts    : this.faqInfo.cts,
			}

			this.$router.push({
				name   : 'faqmanagementupdate',
				params : { data : params }
			})
        },

        deleteConfirm(){
			this.$confirm(
				{
					message: `삭제하시겠습니까?`,
					button: {
						no: '아니오',
						yes: '예'
					},
					callback: confirm => {
						if (confirm) {
						    this.deleteBtn();
						}
					}
				}
			)
		},

        async deleteBtn(){
            let apiParams = new FormData();
            apiParams.append("atclId", this.atclId);
            await axios('post', "/api/admin/board/faq/deleteAll.json", apiParams)
            await this.$router.push('faqmanagement');
        },
	},
}
</script>

